import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import PermanentMedicationEdit from './PermanentMedicationEdit';
import { IPermanentMedicament } from '../PernamentMedicationItem';

interface Props extends BaseModalProps {
	medicament: IPermanentMedicament;
	formType: string;
	onEdit: () => void;
}

const PermanentMedicationEditModal: React.FC<Props> = props => {
	return (
		<BaseModal title='component.permanentMedicationEdit.modalTitle' {...props}>
			<PermanentMedicationEdit
				medicament={props.medicament}
				formType={props.formType}
				onEdit={props.onEdit}
			/>
		</BaseModal>
	);
};

export default PermanentMedicationEditModal;
